angular.module('tgaAdmin')
  .service('reportService', ['$http', 'envService',
    function ($http, envService) {
      const serverAddress = envService.read('serverAddress');

      function getUserReport(params) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/user`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDomainReport(params = {}) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/domain`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getOrdersReport(params) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/order`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addReportToQueue(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}report`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getReport(report_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/${report_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getReports(data) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report`,
          params: data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getProgress(report_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/progress/${report_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      /**
       * Create a consistent filename for reports created in the client application
       * @param {string} name
       * @param {Date} startDate
       * @param {Date} endDate
       * @param {string} extension
       * @returns string
       */
      function generateReportFilename(name = 'Report', startDate, endDate, extension = 'csv') {
        const startTime = startDate ? ` ${moment(startDate).format('YYYY-MM-DD')}` : '';
        const endTime = endDate ? ` thru ${moment(endDate).format('YYYY-MM-DD')}` : '';
        const fileDate = moment().format('YYYY-MM-DD HH-mm-ss');

        if (extension[0] === '.') {
          extension = extension.substr(1);
        }

        return `${name}${startTime}${endTime} (generated ${fileDate}).${extension}`;
      }

      function getReportMetrics(data, timeout) {
        return $http({
          method: 'GET',
          url: `${serverAddress}report/metrics`,
          params: data,
          timeout,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function cancelReport(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}report/cancel`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return {
        getUserReport,
        getDomainReport,
        getOrdersReport,
        addReportToQueue,
        getReport,
        getReports,
        getProgress,
        generateReportFilename,
        getReportMetrics,
        cancelReport,
      };
    }]);
